import ModalWithButtons from './ModalWithButtons';

export default ModalWithButtons;
